export default __webpack_public_path__ + "atomic/_patterns/01-atoms/small-print-link/_small-print-link.twig";